import { useState } from "react";

import { Box, Button, Card, Collapse, Group, UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { IconNote } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";
import PermissionGate from "@/permission/components/PermissionGate";
import { WRITE_PERMISSION_FLAGS } from "@/permission/constants/practitioner-permissions";

import AddClientConfidentialNotes from "./AddClientConfidentialNote";
import ArchiveClientConfidentialNote from "./ArchiveClientConfidentialNote";
import classes from "./ClientConfidentialNote.module.css";
import DisplayClientConfidentialNote from "./DisplayClientConfidentialNote";

export default function ClientConfidentialNote() {
  const [opened, { toggle }] = useDisclosure(false);
  const [openedModal, handlers] = useDisclosure(false);
  const [toggleAddNote, setToggleAddNote] = useState(false);
  const [viewFiledConfidential, setViewFiledConfidential] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [background, setBackground] = useState<string | undefined>("gray.2");

  const handleViewFiledConfidential = () => {
    setRefresh((prev) => !prev);
    handlers.open();
  };

  return (
    <Card bg={background} className={classes.confidentialCard}>
      <Collapse mb="sm" in={opened}>
        <Group justify="center">
          <TextWrapper py="xs" size="xs" variant="bold">
            Not viewable to client · Not included in chart export
          </TextWrapper>
        </Group>
        {toggleAddNote && (
          <AddClientConfidentialNotes
            setRefresh={setRefresh}
            background={background}
            handleToggleReminder={() => setToggleAddNote(false)}
          />
        )}

        <Box
          style={{
            maxHeight: 200,
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarGutter: "stable",
          }}
        >
          <DisplayClientConfidentialNote
            refresh={refresh}
            openModal={openedModal}
            setRefresh={setRefresh}
            modalHandlers={handlers}
            setBackground={setBackground}
          />
        </Box>
        <Group pt="xs" justify={viewFiledConfidential ? "space-between" : "flex-end"}>
          <ArchiveClientConfidentialNote
            refresh={refresh}
            setRefresh={setRefresh}
            openModal={openedModal}
            modalHandlers={handlers}
            setViewFiledConfidential={setViewFiledConfidential}
          />
          {viewFiledConfidential && (
            <Button
              color="black"
              bg={background}
              variant="subtle"
              size="compact-xs"
              onClick={handleViewFiledConfidential}
              data-testid="view-filed-confidential-notes-button"
            >
              <TextWrapper size="sm" td="underline">
                View Filed Notes
              </TextWrapper>
            </Button>
          )}
          {!toggleAddNote && (
            <PermissionGate allowPatient={false} requiredPermissions={WRITE_PERMISSION_FLAGS}>
              <Button
                color="black"
                bg={background}
                variant="outline"
                size="compact-xs"
                onClick={() => setToggleAddNote(true)}
                data-testid="add-confidential-note-button"
              >
                Add Note
              </Button>
            </PermissionGate>
          )}
        </Group>
      </Collapse>

      <Group h="100%" align="center" justify="center">
        <UnstyledButton onClick={toggle} data-testid="confidential-notes-button">
          <Group gap="xs" justify="center">
            <IconNote size={16} />
            <TextWrapper fw={600} size="md" variant="bold">
              Confidential Notes
            </TextWrapper>
          </Group>
        </UnstyledButton>
      </Group>
    </Card>
  );
}
